module.exports = __webpack_public_path__ + "static/studio-b-control-room-3-2624bdc18020283c08cac6f6388351aa.jpg";